<template>
  <div>
    <b-pagination align="center" size="md" :total-rows="count" :value="pageNumber" :per-page="size" @change="userChangedPage"/>
  </div>
</template>

<script>
export default {
  props: ['count', 'offset', 'size'],
  computed: {
    pageNumber() {
      return (this.offset / this.size) + 1;
    },
    totalPageCount() {
      return Math.ceil(this.count / this.size);
    },
  },
  methods: {
    userChangedPage(number) {
      this.$emit('change', number);
    }
  },
};
</script>
